export default __webpack_public_path__ + "static/media/care_device_zoom_out.db948fcb.svg";